export function normalizeDecimalInput(raw: string, opts?: { allowNegative?: boolean }): string {
  const allowNegative = opts?.allowNegative !== false

  let s = String(raw ?? '')
  s = s.replace(',', '.')

  // Keep digits, '.', and optional leading '-'
  let out = ''
  let dotSeen = false

  for (let i = 0; i < s.length; i++) {
    const ch = s[i]

    if (ch >= '0' && ch <= '9') {
      out += ch
      continue
    }

    if (ch === '.' && !dotSeen) {
      dotSeen = true
      out += ch
      continue
    }

    if (ch === '-' && allowNegative && out.length === 0) {
      out += ch
      continue
    }
  }

  return out
}

export function parseDecimalInput(raw: unknown, opts?: { allowNegative?: boolean }): number | null {
  const allowNegative = opts?.allowNegative !== false
  const s0 = typeof raw === 'string' ? raw : raw == null ? '' : String(raw)
  const s = normalizeDecimalInput(s0, { allowNegative }).trim()

  if (s === '' || s === '-' || s === '.') return null
  if (!/^[-]?\d*(\.\d*)?$/.test(s)) return null

  const n = Number(s)
  return Number.isFinite(n) ? n : null
}
